import "./lib/AmplifyClient";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./components/Context/UserContext";
//import './custom-theme.css';                      
import '@aws-amplify/ui-react/styles.css'; // Amplify Auth styles AFTER Tailwind
import './App.css';                        // Your 
// main.tsx or similar
import "./styles/fonts.css";
import "./styles/theme.css";

// TEMP DEBUG: trap any localStorage writes (remove after debugging)
(() => {
const orig = localStorage.setItem.bind(localStorage);

localStorage.setItem = (key: string, value: string) => {
console.log("[localStorage.setItem]", { key, value });
console.trace("[setItem stack]");
return orig(key, value);
};
})(); 

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <App />
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);
